import React from 'react';
import { useTranslation } from 'react-i18next';

const SEVERITY_STYLES = {
    critical: { bg: 'var(--v3-red-glow)', color: 'var(--v3-red)', label: 'CRITICAL' },
    warning:  { bg: 'var(--v3-amber-glow)', color: 'var(--v3-amber)', label: 'WARNING' },
    info:     { bg: 'var(--v3-teal-glow)', color: 'var(--v3-teal)', label: 'INFO' },
};

/**
 * Alert list widget — anomaly/risk alerts feed.
 * Accepts anomaly detection output (array of {tenant_name, severity, message}).
 */
export default function AlertListWidget({ data }) {
    const { t } = useTranslation();
    if (!data?.data) return null;
    let alerts = Array.isArray(data.data) ? data.data : [];
    if (!alerts.length) {
        return <div style={{ padding: 20 }} className="v3-body">{t('No active alerts — all systems nominal.')}</div>;
    }
    alerts = alerts.slice(0, 6);

    return (
        <div style={{ padding: '6px 18px 14px' }}>
            {alerts.map((a, i) => {
                const sev = SEVERITY_STYLES[a.severity] || SEVERITY_STYLES.info;
                const title = a.tenant_name || a.tenantName || t('Unknown');
                const msg = a.message || (a.direction === 'drop' ? t('Sales dropped') : t('Anomaly detected'));
                return (
                    <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '6px 0' }}>
                        <span style={{
                            padding: '2px 7px',
                            borderRadius: 4,
                            fontSize: 9,
                            fontWeight: 700,
                            background: sev.bg,
                            color: sev.color,
                            whiteSpace: 'nowrap',
                        }}>{t(sev.label)}</span>
                        <div style={{ flex: 1, fontSize: 12 }}>
                            <div style={{ fontWeight: 600, color: 'var(--v3-text-primary)' }}>{title}</div>
                            <div className="v3-body" style={{ fontSize: 11.5 }}>{msg}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
